import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=089884f0&scoped=true"
import script from "./banner.vue?vue&type=script&setup=true&lang=ts"
export * from "./banner.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./banner.vue?vue&type=style&index=0&id=089884f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089884f0",
  null
  
)

export default component.exports